import { combineReducers } from 'redux';
// slices
import claimReducer from './slices/claim';
import policyReducer from './slices/policy';
import customHeaderReducer from './slices/customHeader';
import pageReducer from './slices/page';

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  claim: claimReducer,
  policy: policyReducer,
  customHeader: customHeaderReducer,
  page: pageReducer
});

export default rootReducer;
